import React, { useState } from 'react';
import { auth } from '../../firebase/firebaseConfig';
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInAnonymously
} from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { login } from '../../redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const isAdmin = user.email === 'admin@example.com';
      dispatch(login({ user: user.email, isAdmin }));
      navigate('/');
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const isAdmin = user.email === 'admin@example.com';
      dispatch(login({ user: user.email, isAdmin }));
      navigate('/');
    } catch (err) {
      setError('Google sign-in failed. Please try again.');
    }
  };

  const handleAnonymousLogin = async () => {
    try {
      const result = await signInAnonymously(auth);
      const user = result.user;
      dispatch(login({ user: 'Anonymous User', isAdmin: false }));
      navigate('/');
    } catch (err) {
      setError('Anonymous sign-in failed. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>SportsDuniya Login</h2>
        <form onSubmit={handleEmailLogin}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p>OR</p>
        <button className="google-btn" onClick={handleGoogleLogin}>
          Login with Google
        </button>
        <p>OR</p>
        <button className="anon-btn" onClick={handleAnonymousLogin}>
          Continue as Guest
        </button>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
